import React from "react";
import styled from "styled-components";
import { Button } from "@fluentui/react-northstar";

/** État vide (aucun résultat pour le périmètre) */
const EmptyState = ({ title, description, actionLabel, onAction }) => {
    return (
        <Wrapper>
            <Title>{title}</Title>
            {description && <Description>{description}</Description>}
            {actionLabel && (
                <Button primary flat content={actionLabel} onClick={onAction} />
            )}
        </Wrapper>
    );
};

export default EmptyState;

const Wrapper = styled.div`
    background: var(--prh-card);
    border-radius: var(--prh-radius);
    box-shadow: var(--prh-shadow);
    border: 1px solid var(--prh-line);
    padding: 60px 20px;
    text-align: center;
`;

const Title = styled.h3`
    font-size: var(--prh-font-lg);
    font-weight: 600;
    margin: 0 0 6px;
`;

const Description = styled.p`
    font-size: 13px;
    color: var(--prh-muted);
    margin: 0 0 16px;
`;
